const IDLE_TIMER_DEFAULT_TIMING = {
	RELOAD: 600000,
	ATTRACT: 60000,
	SESSION: 30000,
	INTERACTION: 10000,
};

export default IDLE_TIMER_DEFAULT_TIMING;
